import { render, staticRenderFns } from "./fileNotice.vue?vue&type=template&id=2d677a17&scoped=true"
import script from "./fileNotice.vue?vue&type=script&lang=js"
export * from "./fileNotice.vue?vue&type=script&lang=js"
import style0 from "./fileNotice.vue?vue&type=style&index=0&id=2d677a17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d677a17",
  null
  
)

export default component.exports